import type { WorkflowDefinition } from "@/stores/workflowsStore";

export function getConnectorLogoUrl(connectorType: string): string {
  const brandName = connectorType.includes(":") ? connectorType.split(":")[1] : connectorType;
  return `https://ai-icon.b3.fun/logo/${encodeURIComponent(brandName.replace(/\s+/g, "_"))}`;
}

/** Unique connector types referenced by any node in the workflow definition. */
export function getConnectorTypes(definition: WorkflowDefinition | null | undefined): string[] {
  if (!definition?.nodes) return [];
  const types = new Set<string>();
  for (const node of Object.values(definition.nodes)) {
    if (node.connector?.type) types.add(node.connector.type);
  }
  return Array.from(types);
}
